import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILocationHealthCheck } from '@api/types'
import { LocationHealthCheckFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      locationHealthCheckGroups: ILocationHealthCheck[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, ILocationHealthCheck[]>({
  handler: (data) => data.viewer.company.locationHealthCheckGroups,
  name: 'Capacity Location',
})

function fetch(): Promise<ILocationHealthCheck[]> {
  return client.gql.query({ query: locationHealthCheckGroupsQuery }).then(mutateHandler)
}

const locationHealthCheckGroupsQuery = gql`
  query locationHealthChecks {
    viewer {
      company {
        locationHealthCheckGroups {
          ...LocationHealthCheckFragment
        }
      }
    }
  }
  ${LocationHealthCheckFragment}
`

interface MutationInput {
  healthScreeningMessage?: string
  healthScreeningConfirmButtonText?: string
  locationIds: string[]
  followUpQuestionEnabled?: boolean
  followUpQuestionRecipient?: string
  followUpQuestionText?: string
  healthScreeningOverride?: boolean
}

// will want to reload after adding
function add(input: MutationInput) {
  return client.gql.mutate({ mutation: addMutation, variables: { input } })
}

const addMutation = gql`
  mutation createLocationHealthCheckGroup($input: CreateLocationHealthCheckGroupInput!) {
    createLocationHealthCheckGroup(input: $input) {
      locationHealthCheckGroup {
        id
      }
    }
  }
`

// will want to reload after updating
function update(input: MutationInput & { id: string }) {
  return client.gql.mutate({ mutation: updateMutation, variables: { input } })
}

const updateMutation = gql`
  mutation updateLocationHealthCheckGroup($input: UpdateLocationHealthCheckGroupInput!) {
    updateLocationHealthCheckGroup(input: $input) {
      locationHealthCheckGroup {
        id
      }
    }
  }
`

// will want to reload after removing
function remove(input: { id: string }) {
  return client.gql.mutate({ mutation: removeMutation, variables: { input } })
}

const removeMutation = gql`
  mutation deleteLocationHealthCheckGroup($input: DeleteLocationHealthCheckGroupInput!) {
    deleteLocationHealthCheckGroup(input: $input) {
      locationHealthCheckGroup {
        id
      }
    }
  }
`

export default { fetch, add, update, remove }
